import template from './nativeCommonFieldsForm.jade';

let NativeCommonFieldsFormComponent = {
  template: () => { return template },
  controller: function() {
    var vm = this;
    vm.checkMaxLength = function (event, value, maxChar) {
      if (value && value.length >= maxChar) {
        event.preventDefault();
      }
    };

  },
  controllerAs: 'vm',
  bindings: {
    creative: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.nativeCommonFieldsForm', [])
  .component('nativeCommonFieldsForm', NativeCommonFieldsFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/nativeCommonFieldsForm.js
 **/